var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6878 10.0267C25.6925 11.4188 25.2789 12.792 24.4809 14.0346C23.5346 15.5236 22.08 16.776 20.2799 17.6515C18.4797 18.5271 16.4052 18.9911 14.2886 18.9918C12.5186 18.9954 10.7725 18.6702 9.19252 18.0425L1.54834 20.0465L4.0964 14.0346C3.29836 12.792 2.88481 11.4188 2.88942 10.0267C2.89024 8.36206 3.48032 6.73051 4.59356 5.31476C5.70681 3.89901 7.29925 2.75498 9.19252 2.0108C10.7725 1.38317 12.5186 1.05792 14.2886 1.06155H14.9592C17.7545 1.18284 20.3946 2.11075 22.3742 3.66762C24.3538 5.22448 25.5336 7.3009 25.6878 9.49931V10.0267Z",
    stroke: "#959999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostComment);
export default __webpack_public_path__ + "static/media/PostComment.8850d53611923cea282c2b4bd580e571.svg";
export { ForwardRef as ReactComponent };